import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import t from './common/localization';
import RemoveDialog from './RemoveSweetAlertDialog';

const useStyles = makeStyles(theme => ({
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  root: {
        padding: '10px',
        margin: '10px',
        },
}));

const EditCollectionView = ({ content, editPath, endpoint, reSetMap }) => {
  const classes = useStyles();
  const history = useHistory();

  const [selectedId, setSelectedId] = useState(null);
  const [selectedAnchorEl, setSelectedAnchorEl] = useState(null);
  const [removeDialogShown, setRemoveDialogShown] = useState(false);
  const [updateTimestamp, setUpdateTimestamp] = useState(Date.now());

  const menuShow = (anchorId, itemId) => {
    setSelectedAnchorEl(anchorId);
    setSelectedId(itemId);
  };

  const menuHide = () => {
    setSelectedAnchorEl(null);
  };

  const handleOnEdit = (selectedId) => {
    history.push(`${editPath}/${selectedId}`);
    // menuHide();
  };

  const handleOnRemove = (selectedId) => {
    setSelectedId(selectedId);
    setRemoveDialogShown(true);
    // menuHide();
  };

  const handleRemoveResult = () => {
    setRemoveDialogShown(false);
    setUpdateTimestamp(Date.now());
  };

  const Content = content;

  return (
    <>
      <Content
        updateTimestamp={updateTimestamp}
        handleOnEdit={handleOnEdit}
        handleOnRemove={handleOnRemove}
        onMenuClick={menuShow}
        reSetMap={reSetMap}
      />
      <RemoveDialog
        open={removeDialogShown}
        endpoint={endpoint}
        itemId={selectedId}
        onResult={handleRemoveResult}
      />
    </>
  );
};

export default EditCollectionView;
